import { createStore } from 'vuex'
import axios from '@/utils/api'
import wallet from './wallet'
import errors from './errors'
import isEqual from 'lodash/isEqual'
import creditCardIcon from '../assets/img/credit-card-icon.png'
import { ensureCrimeaArea } from '../utils/crimea'

import receiptIcon from '../assets/img/reciept-icon.png'
import walletIcon from '../assets/img/wallet-icon.png'
import * as Sentry from '@sentry/vue'
import { ADDITIONAL_FIELD_COUNTRIES } from '../consts/countries.js'
import { traceRequest } from '../utils/sentryTracing'
import { perfTrace } from '../utils/perfMarks'
import {
  captureDeliveryApiError,
  captureDuplicateApiRequest,
  captureBasketApiError,
  trackApiRequest,
  captureProfileAddressEmpty,
  getCheckoutContext,
} from '../utils/sentryEvents'
import { trackCheckoutError } from '../utils/checkoutAnalytics'
import { normalizeNumericFields } from '../utils/normalizeNumericFields.js'

const store = createStore({
  modules: {
    wallet,
    errors,
    // delivery,
  },
  state: {
    loading: true,
    authed: false,
    country: {
      code: 'RU',
      name: 'Россия',
    },
    orderType: undefined, // )))
    lastOrderParams: false,
    promo: '',
    promoDiscount: {
      DISCOUNT: 0,
      TYPE: null,
    },
    checkoutFields: [],
    deliveryCompanies: [],
    checkoutData: {},
    cities: [],
    pickpoints: {},
    activePaymentType: undefined,
    selectedPickpointInfo: undefined,
    deliveryTypes: [],
    deliveryTypesWithCityObject: {},
    paymentTypes: {},
    paymentTypeIcons: [
      {
        id: 8,
        src: creditCardIcon,
      },
      {
        id: 12,
        src: receiptIcon,
      },
      {
        id: 37,
        src: walletIcon,
      },
    ],
    receivers: [],
    orderData: {
      loading: true,
    },
    selectedDeliveryType: false,
    selectedDeliveryTypeService: false,
    addressInfo: {
      PROFILE: {
        COUNTRY: null,
        AREA: null,
        CITY: null,
        STREET: null,
        BUILD: null,
        CORPUS: null,
        POSTINDEX: null,
        APARTMENT: null,
        FLOOR: null,
        ENTRANCE: null,
        INTERCOM: null,
      },
    },
    userInfo: {
      FIO: '',
      PHONE: '',
      EMAIL: '',
    },
    user: null,
    additionalOrderInfo: {
      orderComment: '',
      needToContact: false,
      contactMethod: '',
      chosenMessenger: '',
      receiveEmails: false,
      acceptTerms: false,
      acceptTerms2: false,
    },
    memberId: false,
    defaultLocation: {
      lat: 55.7522,
      lng: 37.6156,
    },
    dutyEnabled: true,
    field_filterPickpoints: '',
    isList: true,
    deliveryProfiles: [],
    profilePrices: {},
    profilePricesLoading: false,
    basketItems: null,
    basketError: null,
    selectedLanguage:
      window.getCookie('CC_2019_cnew_language') ||
      window.getCookie('CC_2020_cnew_language'),
    errorComplete: '',
    isEditOldProfile: false,
    isDeliveryLoading: false,
    global: false,
    deliveryError: '',
    currentDeliveryPosition: {},
    IS_COUNTRY_GLOBAL: false,
    CUR_LOCATION: { CODE: '', ALPHA2: '' },
    // HTML-текст уведомления о таможенных сборах от бэка (null — попап не показываем)
    CUSTOMS_NOTIFICATIONS: null,
    SELECTED_PROFILE: {},
    // 'isNewProfile' - неавтор. сессия/без профиля
    // 'isSelectedProfile' - профиль с бэка или выбранный профиль
    // 'userEditProfile' - редактирует заполненный профиль
    checkoutScenario: 'isNewProfile',
    profileMode: 'createNew', // 'createNew' | 'updateExisting'
    filteredCountries: {},
    isCompany: false,
    sameAddress: false,
    isDeliveryLoadingWhenProfileSelected: false,
    addressPickedFromSuggest: false,
    fioFieldFocusState: false,
    serviceState: false,
    isBuyerFromFriend: undefined,
    isFriend: undefined,
    headerCity: '',
    headerArea: '',
    headerLocationId: '',
    headerDistributionStore: '',
    isWebview: false,
    searchLocality: [],
  },
  getters: {
    isUseCoralWallet: (state) => !!state.useWalletValue,
    getOrderType: (state) => {
      return state.orderType
    },
    getCountry: (state) => state.country,
    getCurrency: (state) => {
      return state.currency
    },
    getFieldsConfig: (state) => {
      return state.checkoutFields
    },
    getCheckoutData: (state) => {
      return state.checkoutData
    },
    getDeliveryProfiles: (state) => {
      return state.deliveryProfiles
    },
    getCitiesList: (state) => (area) => {
      return state.cities[area]
    },
    getPickpointsList: (state) => (area) => {
      return state.pickpoints[area]
    },
    getActivePaymentType: (state) => {
      return state.activePaymentType
    },
    getDeliveryCompaniesList: (state) => {
      return state.deliveryCompanies
    },
    getSelectedPickpointInfo: (state) => {
      return state.selectedPickpointInfo
    },
    getDeliveryTypes: (state) => {
      return state.deliveryTypes
    },
    getPaymentTypes: (state) => (deliveryId) => {
      return state.paymentTypes[deliveryId]
    },
    getPaymentTypeIcon: (state) => (id) => {
      return state.paymentTypeIcons.find((item) => item.id === id)
    },
    getReceivers: (state) => {
      return state.receivers
    },
    getProfile: (state) => (id) => {
      return state.deliveryProfiles.find((profile) => profile.PROFILE_ID === id)
    },
    getErrorComplete: (state) => {
      return state.errorComplete
    },
    getIsEditOldProfile: (state) => {
      return state.isEditOldProfile
    },
    getCountryCode: (state) => {
      return state.country.code
    },
    isHiddenCommentBlock(state) {
      return ADDITIONAL_FIELD_COUNTRIES.includes(state.country.code)
    },
    orderParams: (state) => {
      return state.orderParams
    },
    needToShowNotification(state) {
      return ['RU', 'GE'].includes(state.country.code)
    },
    getProfileMode: (state) => state.profileMode,
    isCreatingNewProfile: (state) => state.profileMode === 'createNew',
    isUpdatingProfile: (state) => state.profileMode === 'updateExisting',
    getOrderData: (state) => {
      return state.orderData
    },
    isFriendOrBuyerFromFriend: (state) =>
      state.isFriend || state.isBuyerFromFriend,
    isBuyerFromFriend: (state) => state.isBuyerFromFriend,
    getBasketItems: (state) => state.basketItems,
  },
  mutations: {
    toggleServiceState(state, payload) {
      state.serviceState = payload
    },
    updateRow(state, payload) {
      // В случае orderData или wallet применяем функцию normalizeNumericFields,
      // чтобы привести указанные ключи в ожидаемый(цифрофой) формат
      state[payload.row] =
        payload.row === 'orderData' || payload.row === 'wallet'
          ? normalizeNumericFields(payload.payload)
          : payload.payload
    },
    setListOrMap(state, isList) {
      state.isList = isList
    },
    setFilterPickpointField(state, field) {
      state.field_filterPickpoints = field
    },
    // это метод для самых первых данных, которые принимает main.js. Например, userInfo и т.д.
    firstSet(state, payload) {
      for (const c in payload) {
        state[c] = payload[c]
      }
    },
    dutyEnabled: (state, duty) => (state.dutyEnabled = duty),
    RemoveProfile(state, profileId) {
      const index = state.deliveryProfiles.findIndex(
        (el) => el.PROFILE_ID === profileId
      )
      state.deliveryProfiles.splice(index, 1)
    },

    UpdateFieldConfig(state, payload) {
      state.checkoutFields = payload

      if (state.deliveryProfiles && state.deliveryProfiles.length > 0) {
        for (const k in state.deliveryProfiles) {
          const profile = state.deliveryProfiles[k]
          for (const field of payload.ADDRESS_INFO_FIELDS) {
            if (
              !profile.ADDRESS_INFO_FIELDS[field.name] &&
              field.type === 'text'
            )
              profile.ADDRESS_INFO_FIELDS[field.name] = ''
          }
          state.deliveryProfiles[k] = profile
        }
      }
    },
    UpdateDeliveryProfiles(state, payload) {
      const plData = Array.isArray(payload) ? payload[0] : payload
      if (state.deliveryProfiles.length) {
        state.deliveryProfiles.unshift(plData)
      } else {
        state.deliveryProfiles = [plData]
      }
    },
    UpdateAllDeliveryProfiles(state, payload) {
      state.deliveryProfiles = payload
    },
    SetProfilePrices(state, payload) {
      state.profilePrices = payload.reduce((acc, item) => {
        acc[item.profileId] = item
        return acc
      }, {})
    },
    SetProfilePricesLoading(state, value) {
      state.profilePricesLoading = value
    },
    setBasketItems(state, payload) {
      state.basketItems = payload
    },
    setBasketError(state, payload) {
      state.basketError = payload
    },
    UpdateCheckoutData(state, payload) {
      state.checkoutData = payload
    },
    UpdateCitiesList(state, { area, cities }) {
      state.cities[area] = cities
    },
    UpdateDeliveryProfile(state, payload) {
      const plData = Array.isArray(payload) ? payload[0] : payload
      let profile = state.deliveryProfiles.findIndex(
        (item) => item.PROFILE_ID === plData.PROFILE_ID
      )
      state.deliveryProfiles.splice(profile, 1)
      state.deliveryProfiles.unshift(plData)
    },
    UpdatePickpointsList(state, payload) {
      function sortByCityAndAddress(arr, targetCity) {
        // Дополнительная сортировка по полю "NUM"
        arr.sort((a, b) => {
          return b.NUM - a.NUM // Сравнение адресов
        })

        // Сортировка по полю "CITY"
        arr.sort((a, b) => {
          if (a.CITY === targetCity) {
            return -1 // Первый объект с указанным городом
          } else if (b.CITY === targetCity) {
            return 1 // Второй объект с указанным городом
          } else {
            return a.CITY.localeCompare(b.CITY) // Сравнение городов
          }
        })
        return arr
      }

      payload.pickpoints.forEach((el, i) => {
        if (/^№\d+/.test(el.ADDRESS)) {
          payload.pickpoints[i].NUM = Number(
            el.ADDRESS.replace(/^№(\d+).+/, '$1')
          )
        } else {
          payload.pickpoints[i].NUM = 50000
        }
        el.idx = i
      })

      const pickpoints = sortByCityAndAddress(
        payload.pickpoints,
        payload.positionData
      )
      state.pickpoints[payload.positionData] = Object.freeze(pickpoints)
    },

    SmartUpdateDeliveryTypesList(state, payload) {
      for (const dtype of payload) {
        if (state.deliveryTypes.find((el) => el.ID === dtype.ID)) {
          for (const item of dtype.ITEMS) {
            if (!state.deliveryTypes.ITEMS.find((el) => el.ID === item.ID)) {
              state.deliveryTypes.ITEMS.push(item)
            }
          }
        } else {
          state.deliveryTypes.push(dtype)
        }
      }
    },

    UpdateDeliveryTypesList(state, payload) {
      if (!payload) {
        const sentryEventId = Sentry.captureMessage(
          `Нет способов доставки в городе ${state.currentDeliveryPosition.CITY_NAME}, ${state.currentDeliveryPosition.AREA_NAME} области в стране ${state.country.code}`
        )
        trackCheckoutError({
          step: 'delivery',
          errorType: 'checkout.delivery_api.no_delivery_types',
          errorMessage: `no delivery types for ${state.currentDeliveryPosition?.CITY_NAME || 'unknown'}`,
          sentryEventId,
        })
      }
      if (state.country.code === 'UA') {
        payload.sort((a, b) => {
          if (a.ID === 'PICK_POINT') {
            return -1 // a должен быть перед b
          }
          if (b.ID === 'PICK_POINT') {
            return 1 // b должен быть перед a
          }
          return 0 // порядок не имеет значения
        })
      } else if (state.country.code === 'RU' || state.country.code === 'KZ') {
        payload.sort((a, b) => {
          if (a.ID === 'COURIER') {
            return -1 // a должен быть перед b
          }
          if (b.ID === 'COURIER') {
            return 1 // b должен быть перед a
          }
          return 0 // порядок не имеет значения
        })
      }
      state.deliveryTypes = payload
    },
    UpdateDeliveryTypesListWithCity(state, { deliveryCity, deliveryData }) {
      state.deliveryTypesWithCityObject[deliveryCity] = deliveryData
    },
    UpdatePaymentTypesList(state, { payload, deliveryServiceId }) {
      state.paymentTypes[deliveryServiceId] = payload
    },
    UpdateReceiversList(state, payload) {
      state.receivers = payload
    },
    UpdateReceiverData(state, payload) {
      let receiver = state.receivers.findIndex((item) => item.ID === payload.ID)
      state.receivers[receiver] = payload
    },
    UpdateActivePaymentType(state, payload) {
      state.activePaymentType = payload
    },
    UpdateDeliveryCompaniesList(state, payload) {
      for (let item of payload) {
        const companyData = {
          id: item.ID,
          name: item.NAME,
          icon: item.IMAGE,
          desription: item.DESCRIPTION,
          paymentSystems: item.PAYSYSTEMS,
          price: item.PRICE,
        }
        const index = state.deliveryCompanies.findIndex(
          (item) => item.id === companyData.id
        )
        if (index === -1) {
          state.deliveryCompanies.push(companyData)
        } else {
          state.deliveryCompanies[index] = companyData
        }
      }
    },
    UpdateSelectedPickpointInfo(state, payload) {
      state.selectedPickpointInfo = payload
    },
    // UpdateCoralWallet(state, payload) {
    //   state.coralWalletInfo = payload
    // },
    UpdateSelectedDeliveryType(state, payload) {
      state.selectedDeliveryType = payload
    },
    UpdateSelectedDeliveryTypeService(state, payload) {
      state.selectedDeliveryTypeService = payload
    },
    UpdateAdditionalOrderInfo(state, payload) {
      state.additionalOrderInfo = payload
    },
    UpdateMemberId(state, payload) {
      state.memberId = payload
    },
    UpdatePromo(state, payload) {
      state.promoDiscount = payload.result
      state.promo = payload.promo
    },
    updateDefaultLocation(state, payload) {
      state.defaultLocation = {
        lat: payload.lat(),
        lng: payload.lng(),
      }
    },
    updateLastOrderParams(state, payload) {
      state.lastOrderParams = payload
    },
    UpdateError(state, error) {
      state.errorComplete = error
    },
    updateIsEditOldProfile(state, payload) {
      state.isEditOldProfile = payload
    },
    UpdateSelectedProfile(state, payload) {
      state.SELECTED_PROFILE = payload
    },
    setCheckoutScenario(state, payload) {
      state.checkoutScenario = payload
    },
    setAddressPickedFromSuggest(state, payload) {
      state.addressPickedFromSuggest = Boolean(payload)
    },
    setFilteredCountries(state, payload) {
      state.filteredCountries = payload
    },
    setIsCompany(state, payload) {
      state.isCompany = payload
    },
    setAddressAsSame(state, payload) {
      state.sameAddress = payload
    },
    updateFieldsRequirement(state) {
      if (!state.checkoutFields.ADDITIONAL_FIELDS?.length) return

      for (let field of state.checkoutFields.ADDITIONAL_FIELDS) {
        if (state.isCompany) {
          if (['FAKTURA_INN', 'FAKTURA_COMPANY'].includes(field.name)) {
            field.required = true
          }
          if (field.name === 'FAKTURA_FIO') {
            field.required = false
          }
        } else {
          if (['FAKTURA_INN', 'FAKTURA_COMPANY'].includes(field.name)) {
            field.required = false
          }
          if (field.name === 'FAKTURA_FIO') {
            field.required = true
          }
        }
      }
    },
    setLoadingStatus(state, payload) {
      state.loading = payload
    },
    setProfileMode(state, mode) {
      state.profileMode = mode
    },
    setOrderParams(state, orderParams) {
      state.orderParams = orderParams
    },
    setIsDeliveryLoadingWhenProfileSelected(state, payload) {
      state.isDeliveryLoadingWhenProfileSelected = payload
    },
    setFioFieldFocusState(state, payload) {
      state.fioFieldFocusState = payload
    },
    updateAddressInfo(state, payload) {
      state.addressInfo = payload
    },
    setIsBuyerFromFriend(state, payload) {
      state.isBuyerFromFriend = payload
    },
    setIsFriend(state, payload) {
      state.isFriend = payload
    },
  },
  actions: {
    RESET_PROMO({ commit }) {
      commit('UpdatePromo', { result: { DISCOUNT: 0, TYPE: null }, promo: '' })
    },
    async GET_PROMO({ commit }, promo) {
      return traceRequest('GET /promo', async () => {
        try {
          const response = await axios.get('/promo', {
            params: {
              promo: promo,
            },
          })
          if (response.data.error === 'deauthorization') {
            window.location = '/login/?BACK_URL=/checkout_new/'
          }

          if (response.data.error !== '') {
            throw new Error('error promo ' + response.data.error)
          } else if (response.data.result) {
            commit('UpdatePromo', {
              result: response.data.result,
              promo: promo,
            })
          } else {
            throw new Error('error promo ' + JSON.stringify(response.data))
          }
        } catch (err) {
          console.log('GET_PROMO', err)
          throw new Error(err)
        }
      })
    },
    async GET_ORDER({ commit }, params) {
      return traceRequest('GET /getOrder', async () => {
        try {
          const response = await axios.get('/getOrder', { params })
          if (response.data.result) {
            commit('setOrderParams', {
              id: response.data.result.ORDER_ID,
              sum: response.data.result.NEED_PAY,
            })
          }
        } catch (e) {
          console.log(e)
        }
      })
    },
    async GET_INITIAL_DATA({ commit, state }) {
      return traceRequest('GET /init', async () => {
        try {
          const response = await axios.get('/init')
          const result = response?.data?.result

          if (response?.data?.error) {
            const sentryEventId = Sentry.captureMessage(
              'GET_INITIAL_DATA ' +
                response.data.error +
                ' response.data.errorTitle ' +
                response.data.errorTitle
            )
            trackCheckoutError({
              step: 'delivery',
              errorType: 'checkout.init.error_response',
              errorMessage: response.data.errorTitle || response.data.error,
              sentryEventId,
            })
          }
          if (response?.data?.error === 'deauthorization') {
            window.location = '/login/?BACK_URL=/checkout_new/'
          }

          console.log('GET_INITIAL_DATA', response.data)

          if (!result || !Object.keys(result).length) {
            throw new Error(response?.data?.error || 'Empty result from /init')
          }

          commit('UpdateFieldConfig', result.FIELDS_CONFIG || {})
          commit('setIsBuyerFromFriend', result.FRIEND_REF ?? null)
          commit('setIsFriend', result.FRIEND ?? null)

          commit('firstSet', { user: result.USER || null })

          const profileLast = result.PROFILE_LAST
          if (profileLast?.length) {
            // Проверка на пустые поля адреса в профиле
            const profile = profileLast[0]
            const addressFields = profile?.ADDRESS_INFO_FIELDS || {}
            const emptyFields = []

            for (const field of ['CITY', 'AREA', 'STREET', 'BUILD']) {
              if (!addressFields[field]) {
                emptyFields.push(field)
              }
            }

            if (emptyFields.length > 0) {
              captureProfileAddressEmpty({
                context: getCheckoutContext({ state }),
                emptyFields,
              })
            }

            commit('firstSet', {
              SELECTED_PROFILE: profile,
            })
            commit('setCheckoutScenario', 'isSelectedProfile')
            commit('setProfileMode', 'updateExisting')
            const isCompany =
              profile?.ADDITIONAL_INFO_FIELDS?.IS_COMPANY ?? false
            commit('setIsCompany', isCompany)
          }

          commit('firstSet', {
            IS_COUNTRY_GLOBAL: result.IS_COUNTRY_GLOBAL ?? false,
          })
          commit('firstSet', {
            CUR_LOCATION: result.CUR_LOCATION || { CODE: '', ALPHA2: '' },
          })
          commit('setFilteredCountries', result.COUNTRIES_FILTERED || {})
          commit('firstSet', {
            isWebview: !!result.WEBVIEW,
          })
          commit('firstSet', {
            searchLocality: result.CHECKOUT_OPTIONS?.searchLocality || [],
          })
          commit('firstSet', {
            CUSTOMS_NOTIFICATIONS: result.CUSTOMS_NOTIFICATIONS || null,
          })

          return result.CHECKOUT_OPTIONS || {}
        } catch (err) {
          console.log('catch ERROR ', err)
          throw new Error(err)
        }
      }) // end Sentry.startSpan
    },
    async GET_DELIVERY_PROFILES({ commit }) {
      return traceRequest('GET /profiles', async () => {
        try {
          const response = await perfTrace('checkout:profiles', () =>
            axios.get('/profiles')
          )
          if (response.data.error === 'deauthorization') {
            window.location = '/login/?BACK_URL=/checkout_new/'
          }

          if (response.data.result && response.data.result.length) {
            commit('UpdateAllDeliveryProfiles', response.data.result)
          } else {
            console.log('profiles in if ', response.data.error)
            throw new Error(response.data.error)
          }
        } catch (err) {
          console.log('profiles ', err)
          throw new Error(err)
        }
      })
    },
    async GET_PROFILE_PRICES({ commit }) {
      return traceRequest('GET /getProfilePrice', async () => {
        commit('SetProfilePricesLoading', true)
        try {
          const response = await axios.get('/getProfilePrice')
          if (response.data.result) {
            commit('SetProfilePrices', response.data.result)
          }
        } catch (err) {
          console.log('getProfilePrice ', err)
        } finally {
          commit('SetProfilePricesLoading', false)
        }
      })
    },
    async GET_BASKET({ commit, state }) {
      return traceRequest('GET /basket', async () => {
        const endpoint = '/basket'
        const { isDuplicate, repeatCount, intervalMs } =
          trackApiRequest(endpoint)
        if (isDuplicate && repeatCount >= 3) {
          captureDuplicateApiRequest({
            context: getCheckoutContext({ state }),
            endpoint,
            repeatCount,
            intervalMs,
          })
        }
        try {
          const response = await axios.get('/basket')
          const data = response?.data || {}
          if (data.error === 'deauthorization') {
            window.location = '/login/?BACK_URL=/checkout_new/'
            return
          }
          if (data.error) {
            commit('setBasketItems', null)
            commit('setBasketError', String(data.error))
            captureBasketApiError({
              context: getCheckoutContext({ state }),
              errorCode: data.error,
              responseStatus: response?.status,
            })
            return
          }
          commit('setBasketError', null)
          commit('setBasketItems', data.result?.items)
        } catch (err) {
          console.log('GET_BASKET', err)
          commit('setBasketItems', null)
          commit('setBasketError', String(err || 'basket_request_failed'))
          captureBasketApiError({
            context: getCheckoutContext({ state }),
            errorCode: String(err),
            responseStatus: err?.status,
          })
        }
      })
    },
    // todo: не используется в проекте
    async GENERATE_CHECKOUT_DATA({ commit, getters }) {
      const checkoutData = getters.getCheckoutData || {}
      const addressFields = getters.getFieldsConfig?.ADDRESS_INFO_FIELDS || []
      for (const field of addressFields) {
        if (field?.name) {
          checkoutData[field.name] = null
        }
      }
      commit('UpdateCheckoutData', checkoutData)
    },
    async UPDATE_CHECKOUT_DATA({ commit }, payload) {
      if (Object.keys(payload).length) {
        commit('UpdateCheckoutData', payload)
      }
    },
    async UPDATE_DELIVERY_PROFILE({ commit, state }, payload) {
      return traceRequest('PATCH /profiles', async () => {
        try {
          payload.PROFILE.COUNTRY = state?.country?.code || 'CA'
          if (typeof payload.PROFILE.PHONE !== 'undefined')
            payload.PROFILE.PHONE = payload.PROFILE.PHONE.replace(
              /[^0-9+]/g,
              ''
            )

          if (typeof payload.PROFILE.BUILD === 'undefined') {
            payload.PROFILE.BUILD = '0'
          }
          if (typeof payload.PROFILE.APARTMENT === 'undefined') {
            payload.PROFILE.APARTMENT = '0'
          }

          const response = await axios.patch('/profiles', payload)
          if (response?.data?.error) {
            console.error(response.data.error)
            commit('UpdateError', response.data.error)
            return
          } else {
            commit('UpdateError', '')
          }

          if (response?.data?.result) {
            commit('UpdateDeliveryProfile', response.data.result)
          }
        } catch (error) {
          console.log(error)
        }
      })
    },

    async GET_DELIVERY_TYPES({ commit, state }, positionData) {
      return traceRequest('GET /delivery', async () => {
        state.isDeliveryLoading = true
        if (!positionData?.CITY_NAME)
          positionData.CITY_NAME = positionData?.AREA_NAME
        if (state?.country?.code === 'RU') ensureCrimeaArea(positionData)

        const endpoint = '/delivery'

        // Проверка на duplicate requests
        const { isDuplicate, repeatCount, intervalMs } =
          trackApiRequest(endpoint)
        console.log(
          endpoint,
          'isDuplicate',
          isDuplicate,
          'repeatCount',
          repeatCount,
          'intervalMs',
          intervalMs
        )
        if (isDuplicate && repeatCount >= 3) {
          captureDuplicateApiRequest({
            context: getCheckoutContext({ state }),
            endpoint,
            repeatCount,
            intervalMs,
          })
        }

        try {
          const countryCode = state?.country?.code || 'RU'

          const response = await axios.get(endpoint, {
            params: {
              COUNTRY: countryCode,
              CITY: positionData.CITY_NAME || '',
              AREA: positionData.AREA_NAME || '',
            },
          })

          if (
            response?.data?.error &&
            response?.data?.error !== 'deauthorization'
          ) {
            captureDeliveryApiError({
              context: getCheckoutContext({ state }),
              endpoint,
              errorCode: response.data.error,
              responseStatus: response.status,
            })
          }

          const result = response?.data?.result
          state.isDeliveryLoading = false
          state.currentDeliveryPosition = positionData

          if (response?.data?.error === 'deauthorization') {
            window.location = '/login/?BACK_URL=/checkout_new/'
          }
          state.deliveryError = response?.data?.error || ''

          if (positionData.smart) {
            commit('SmartUpdateDeliveryTypesList', result || [])
          } else {
            commit('UpdateDeliveryTypesList', result || [])

            const deliveryCity = positionData.CITY_NAME
            commit('UpdateDeliveryTypesListWithCity', {
              deliveryCity,
              deliveryData: result || [],
            })
          }
        } catch (err) {
          commit('addApiError', err)
          captureDeliveryApiError({
            context: getCheckoutContext({ state }),
            endpoint,
            errorCode: err.message || 'network_error',
            responseStatus: 0,
          })
          state.isDeliveryLoading = false
          throw err
        }
      }) // end Sentry.startSpan
    },

    async GET_LOCATION({ state }) {
      return traceRequest('GET /location', async () => {
        const response = await axios.get('/restApi/v4/location/getLocation', {
          baseURL: '',
        })
        const data = response.data
        state.headerCity = data.city || ''
        state.headerArea = data.area || ''
        state.headerLocationId = data.locationId || ''
        state.headerDistributionStore = data.distributionStore || ''
        return data
      })
    },

    async CHECK_LOCALITY(_, { city, area }) {
      return traceRequest('GET /checkLocality', async () => {
        const response = await axios.get('/checkLocality', {
          params: { city, area },
        })
        return response.data
      })
    },

    async CHANGE_LOCALITY(_, { city, area }) {
      return traceRequest('POST /changeLocality', async () => {
        const response = await axios.post('/changeLocality', {
          city,
          area,
        })
        return response.data
      })
    },

    async GET_PAYMENT_TYPES(
      { commit, state },
      { deliveryServiceId, positionData }
    ) {
      return traceRequest('GET /payments', async () => {
        state.loading = true
        if (state?.country?.code === 'RU' && positionData)
          ensureCrimeaArea(positionData)

        try {
          const response = await perfTrace('checkout:payments', () =>
            axios.get('/payments', {
              params: {
                deliveryId: deliveryServiceId,
                COUNTRY: state?.country?.code || 'null',
                CITY: positionData?.CITY_NAME || 'null',
                AREA: positionData?.AREA_NAME || 'null',
              },
            })
          )

          if (response?.data?.error === 'deauthorization') {
            window.location = '/login/?BACK_URL=/checkout_new/'
          }

          const result = response?.data?.result
          if (result && result.length) {
            // ID, который пользователь выбирал в прошлый раз
            const lastId =
              state.PROFILE_LAST?.LAST_CHOICES?.LAST_PAYMENT_TYPE?.ID
            // если он есть в новом списке — берём его, иначе первый
            const activeId =
              lastId &&
              result.some((pt) => {
                return pt.ID === lastId
              })
                ? lastId
                : result[0]?.ID

            commit('UpdatePaymentTypesList', {
              payload: result,
              deliveryServiceId: deliveryServiceId,
            })
            commit('UpdateActivePaymentType', activeId)
          } else {
            throw new Error(
              response?.data?.error || 'Empty payment types result'
            )
          }
        } catch (err) {
          console.error('GET_PAYMENT_TYPES error:', err)
          throw err
        } finally {
          state.loading = false
        }
      }) // end Sentry.startSpan
    },
    async GET_PICKPOINTS({ commit, state }, position) {
      return traceRequest('GET /pickpoints', async () => {
        if (state?.country?.code === 'RU' && position)
          ensureCrimeaArea(position)

        const endpoint = '/pickpoints'

        // Проверка на duplicate requests
        const { isDuplicate, repeatCount, intervalMs } =
          trackApiRequest(endpoint)
        console.log(
          endpoint,
          'isDuplicate',
          isDuplicate,
          'repeatCount',
          repeatCount,
          'intervalMs',
          intervalMs
        )
        if (isDuplicate && repeatCount >= 3) {
          captureDuplicateApiRequest({
            context: getCheckoutContext({ state }),
            endpoint,
            repeatCount,
            intervalMs,
          })
        }
        try {
          const response = await perfTrace('checkout:pickpoints', () =>
            axios.get(endpoint, {
              params: {
                COUNTRY: state?.country?.code || 'RU',
                CITY: position?.CITY_NAME || 'null',
                AREA: position?.AREA_NAME || 'null',
              },
            })
          )
          if (response?.data?.error === 'deauthorization') {
            window.location = '/login/?BACK_URL=/checkout_new/'
          }

          commit('UpdatePickpointsList', {
            positionData: position?.CITY_NAME,
            pickpoints: response?.data?.result || [],
          })
        } catch (err) {
          console.log('pickpoints err', err)
          captureDeliveryApiError({
            context: getCheckoutContext({ state }),
            endpoint: '/pickpoints',
            errorCode: err.message || 'network_error',
            responseStatus: 0,
          })
        }
      }) // end Sentry.startSpan
    },
    // todo: не используется в проекте
    async SAVE_NEW_RECEIVER({ commit }, data) {
      return traceRequest('POST /receivers', async () => {
        if (data?.PHONE) data.PHONE = data.PHONE.replace(/[^0-9+]/g, '')
        const response = await axios.post('/receivers', data)
        if (response?.data?.error === 'deauthorization') {
          window.location = '/login/?BACK_URL=/checkout_new/'
        }

        if (response?.data?.result) {
          commit('UpdateReceiversList', response.data.result)
        }
      })
    },
    // todo: не используется в проекте
    async UPDATE_RECEIVER({ commit }, data) {
      return traceRequest('PATCH /receivers', async () => {
        if (data?.PHONE) data.PHONE = data.PHONE.replace(/[^0-9+]/g, '')
        const response = await axios.patch('/receivers', data)
        if (response?.data?.error === 'deauthorization') {
          window.location = '/login/?BACK_URL=/checkout_new/'
        }

        if (response?.data?.result) {
          commit('UpdateReceiverData', response.data.result)
        }
      })
    },

    async DELETE_DELIVERY_PROFILE({ commit }, profileId) {
      return traceRequest('DELETE /profiles', async () => {
        try {
          const response = await axios.delete('/profiles', {
            data: {
              profileId: profileId,
            },
          })
          if (response?.data?.error === 'deauthorization') {
            window.location = '/login/?BACK_URL=/checkout_new/'
          }

          if (response?.data?.result) {
            commit('RemoveProfile', profileId)
          }
        } catch (e) {
          console.log(e)
        }
      })
    },
    async SAVE_NEW_PROFILE({ commit }, data) {
      return traceRequest('POST /profiles', async () => {
        try {
          if (typeof data?.PROFILE?.BUILD === 'undefined') {
            data.PROFILE.BUILD = '0'
          }
          if (typeof data?.PROFILE?.APARTMENT === 'undefined') {
            data.PROFILE.APARTMENT = '0'
          }
          if (typeof data?.PROFILE?.PHONE !== 'undefined') {
            data.PROFILE.PHONE = data.PROFILE.PHONE.replace(/[^0-9+]/g, '')
          }
          const response = await axios.post('/profiles', data)
          if (response?.data?.error === 'deauthorization') {
            window.location = '/login/?BACK_URL=/checkout_new/'
          }

          if (response?.data?.error) {
            console.error(response.data.error)
            commit('UpdateError', response.data.error)
            return
          } else {
            commit('UpdateError', '')
          }

          if (response?.data?.result?.[0]) {
            commit('UpdateDeliveryProfiles', response.data.result[0])
          }
        } catch (error) {
          console.error(error)
        }
      })
    },
    async GET_ORDER_DATA({ commit, state }, data = {}) {
      return traceRequest('GET /order', async () => {
        state.loading = true
        let orderParams = ''

        if (data.deliveryId) {
          if (state?.country?.code === 'RU' && data.positionData)
            ensureCrimeaArea(data.positionData)
          const query = {
            bonusUseValue: state?.wallet?.use ?? 0,
            promo: state?.promo || '',
            deliveryId: data.deliveryId,
            paymentId: data.paymentId,
            pickPoint: data.pickPoint,
            COUNTRY: state?.country?.code || 'RU',
            CITY: data.positionData?.CITY_NAME || '',
            AREA: data.positionData?.AREA_NAME || '',
            PROFILE: data.profile,
            dutyEnabled: state?.dutyEnabled ?? true,
          }
          orderParams = { params: query }
        }

        if (isEqual(state.lastOrderParams, orderParams)) {
          state.loading = false
          return
        }

        commit('updateLastOrderParams', orderParams)
        commit('resetApiErrors')
        try {
          const response = await axios.get('/order', orderParams)
          const result = response?.data?.result
          const error = response?.data?.error
          if (error) {
            console.error(error + '\n try page reload')
          } else if (result) {
            const wallet = { ...(state.wallet || {}) }
            wallet.CW_VALUE_LIMIT = result.CW_VALUE_LIMIT ?? 0
            wallet.CW_VALUE_ROUND_STEP = result.CW_VALUE_ROUND_STEP
            commit('updateRow', { payload: wallet, row: 'wallet' })
            commit('updateRow', { payload: result, row: 'orderData' })

            if (state.authed) {
              const {
                CW_VALUE,
                CW_VALUE_LIMIT,
                CW_VALUE_ROUND_STEP,
                BONUS_VALUE,
              } = result
              commit('updateRow', {
                payload: {
                  CW_VALUE: CW_VALUE ?? 0,
                  CW_VALUE_LIMIT: CW_VALUE_LIMIT ?? 0,
                  CW_VALUE_ROUND_STEP: CW_VALUE_ROUND_STEP,
                  BONUS_VALUE: BONUS_VALUE ?? 0,
                  use: state?.wallet?.use ?? 0,
                },
                row: 'wallet',
              })
            }
          }
        } catch (err) {
          commit('addApiError', err)
          console.error(err)
        } finally {
          state.loading = false
        }
      }) // end Sentry.startSpan
    },
    async CREATE_ORDER(_, orderData) {
      return traceRequest('POST /order', async () => {
        const response = await perfTrace('checkout:order-create', () =>
          axios.post('/order', orderData)
        )
        return response
      })
    },
  },
})

export default store
